import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-custom-pdf-viewer',
  templateUrl: './custom-pdf-viewer.component.html',
  styleUrls: ['./custom-pdf-viewer.component.scss'],
})
export class CustomPdfViewerComponent implements OnInit {
  @Input() fullscreenDiv;
  @Input() height = '80vh';
  @Input() filenameForDownload;
  @Input() showBookmarkButton = false;
  @Input() showDownloadButton = true;
  @Input() showFindButton = true;
  @Input() showHandToolButton = true;
  @Input() showOpenFileButton = false;
  @Input() textLayer = true;
  @Input() zoom = 'page-width';
  @Input() base64Src$: Observable<string>;

  showOpenFullscreenBtn = true;
  @ViewChild('fullscreen') divRef;
  fullScreenMode: boolean;

  constructor() {}

  ngOnInit(): void {}

  toggleFullScreen() {
    const elem = this.divRef.nativeElement;

    if (this.showOpenFullscreenBtn) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullscreen();
        elem.webkitRequestFullScreen(elem.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      // alert('Press Ok To Close Fullscreen');
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
      // else if (document.mozCancelFullScreen) {
      //   document.mozCancelFullScreen();
      // }
      // else if (document.webkitCancelFullScreen) {
      //   document.webkitCancelFullScreen();
      // }
    }

    this.showOpenFullscreenBtn = !this.showOpenFullscreenBtn;
  }
}
